import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request table view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Extending the summTreeColumn data filter to calculate and display summary values
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold the formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with the formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from the existing summColumn filter
        );

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'BetShopName', // Column ID
                                    header: _('Punto de Venta'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ActionTittle', // Column ID for action buttons
                                    header: '', // No header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    hidden: !devConfig.getPermAction('withdrawalRequestsBetShop', 'Edit'), // Conditional visibility based on permissions
                                    css: 'prm-withdrawalRequestsBetShop', // CSS class for styling
                                    template: function (obj) {
                                        // Template function for rendering action buttons
                                        if (obj.State == 'A') {
                                            return "<span placeholder='Aprobar' class='webix_icon wxi-close approve'></span><span class='webix_icon wxi-close torefuse'></span>";
                                        } else {
                                            if (obj.State == 'P') {
                                                return "<span placeholder='Pagar' class='webix_icon wxi-close pay'></span>";
                                            } else {
                                                return '';
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'detailTittle', // Column ID for detail button
                                    header: '', // No header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text with localization
                                    template: function (obj) {
                                        // Template function for rendering detail button
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: 'Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID for client ID
                                    header: _('ID Cliente'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID for amount
                                    header: _('Valor'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content type
                                },
                                {
                                    id: 'State', // Column ID for state
                                    header: _('Estado'), // Column header with localization
                                    options: [
                                        // Options for state dropdown
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Pagada') },
                                        { id: 'E', value: _('Eliminado') },
                                        { id: 'P', value: _('Pendiente') },
                                        { id: 'R', value: _('Rechazado') },
                                    ],
                                },
                                {
                                    id: 'CreatedLocal', // Column ID for creation date
                                    header: _('Fecha Creación'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PaymentDate', // Column ID for payment date
                                    header: _('Fecha Pagado'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ByAllowDate', // Column ID for allowed date
                                    header: _('Por fecha de retiro pagado'), // Column header with localization
                                    options: [
                                        // Options for allowed date dropdown
                                        { id: '0', value: _('No') },
                                        { id: '1', value: _('Sí') },
                                    ],
                                },
                            ],
                            onClick: {
                                // Event handlers for click events on buttons
                                details: function (euv, id) {
                                    // Handler for detail button click
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('windowDetailsWithdrawal').show(); // Show details in a window for small screens
                                    } else {
                                        $$('dColl').expand(); // Expand details for larger screens
                                        $$('a5').scrollTo(0, 500); // Scroll to specific position
                                    }
                                },
                                pay: function (euv, id) {
                                    // Handler for pay button click
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Confirmation dialog for payment
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Pagar Nota de Retiro?'),
                                        ok: _('Pagar Nota'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to pay withdrawal request
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/PayWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                item.State = 'I'; // Update item state to 'Paid'
                                                                webix.message(_('Nota de Retiro Pagada')); // Show success message
                                                                vvthis.$$('table').clearAll(); // Clear the table
                                                                vvthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                approve: function (euv, id) {
                                    // Handler for approve button click
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Confirmation dialog for approval
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Nota de Retiro?'),
                                        ok: _('Aprobar Nota'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to approve withdrawal request
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                item.State = 'P'; // Update item state to 'Pending'
                                                                webix.message(_('Nota de Retiro Aprobado')); // Show success message
                                                                vvthis.$$('table').clearAll(); // Clear the table
                                                                vvthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                torefuse: function (euv, id) {
                                    // Handler for refuse button click
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Confirmation dialog for refusal
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar Nota de Retiro?'),
                                        ok: _('Rechazar Nota'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to cancel withdrawal request
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/CancelClientRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                item.State = 'E'; // Update item state to 'Rejected'
                                                                webix.message(_('Nota de Retiro Rechazada')); // Show success message
                                                                vvthis.$$('table').clearAll(); // Clear the table
                                                                vvthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            editable: true, // Enable editing
                            footer: true, // Show footer
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // ID for the pager
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the DataTable
        var url = devConfig.geturlApi() + 'es/Client/GetClientWithdrawalRequests'; // API URL for fetching withdrawal requests
        var filter = ''; // Filter string for requests
        var flag = false; // Flag for export operation

        // Event listener for filtering withdrawal requests
        this.on(this.app, 'withdrawalReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // String to hold query parameters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom parameter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo parameter
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other parameters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom parameter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo parameter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add MinCreatedLocal parameter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add MaxCreatedLocal parameter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data into the grid
            $$('filterPopup').hide(); // Hide the filter popup
            filter = string1; // Update the filter string
        });

        // Event listener for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for starting edit on a cell
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'Action') {
                // Check if the edited column is Action
                var options = this.getColumnConfig('Action').collection; // Get action options
                if (item.State == 'A') {
                    options.remove('P'); // Remove 'Pay' option if state is 'Approved'
                } else if (item.State == 'P') {
                    options.remove('A'); // Remove 'Approve' option if state is 'Pending'
                } else {
                    return false; // Prevent editing for other states
                }
                console.log(id);
            }
        });

        // Event listener for stopping edit on a cell
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row); // Get the edited item
            console.log(item);
            if (state.value != state.old) {
                // Check if the value has changed
                if (state.value == 'A') {
                    // If approved
                    webix
                        .ajax() // AJAX request to approve withdrawal request
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'P'; // Update item state to 'Pending'
                                webix.message('Cell value was changed'); // Show success message
                            },
                        });
                }
                if (state.value == 'P') {
                    // If paid
                    webix
                        .ajax() // AJAX request to pay withdrawal request
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'I'; // Update item state to 'Paid'
                                webix.message('Cell value was changed'); // Show success message
                            },
                        });
                }
                if (state.value == 'E') {
                    // If rejected
                    webix
                        .ajax() // AJAX request to cancel withdrawal request
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'E'; // Update item state to 'Rejected'
                                webix.message('Cell value was changed'); // Show success message
                            },
                        });
                }
            }
        });

        // Event listener for exporting filtered data
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set flag for export operation
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index for export
            } else {
                firstfirst = filterData.first; // Use original first index
            }
            grid.load(url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter); // Load data for export
            $$('datatable').attachEvent(
                'onAfterLoad',
                function () {
                    // Event after loading data
                    if (flag) {
                        var size = $$('datatable').getPager().config.size; // Get pager size
                        var page = $$('datatable').getPage(); // Get current page
                        var first = size * page; // Calculate first index for export
                        var last = first + size - 1; // Calculate last index for export
                        if ($$('Export').getValue() == '1') {
                            // If exporting to Excel
                            for (var j = 0; j < grid.config.columns.length; j++) {
                                if (grid.config.columns[j].exportType) {
                                    delete grid.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                // Trigger export data event
                                {
                                    NameReport:
                                        'Retiros' +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(),
                                    TypeReport: 'Excel', // Set report type to Excel
                                },
                            ]);
                            webix.toExcel(grid, {
                                // Export to Excel
                                filter: function (obj) {
                                    return (
                                        $$('datatable').getIndexById(obj.id) >= first &&
                                        $$('datatable').getIndexById(obj.id) <= last
                                    ); // Filter data for export
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    'Retiros', // Set filename for export
                                ignore: { detailTittle: true }, // Ignore detail title in export
                                footer: false, // Do not include footer in export
                            });
                        } else {
                            if ($$('Export').getValue() == '2') {
                                // If exporting to PDF
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            'Retiros' +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(),
                                        TypeReport: 'PDF', // Set report type to PDF
                                    },
                                ]);
                                webix.toPDF($$('datatable'), {
                                    // Export to PDF
                                    filter: function (obj) {
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        ); // Filter data for export
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Retiros', // Set filename for export
                                    autowidth: true, // Enable auto width for PDF
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                    footer: false, // Do not include footer in export
                                });
                            }
                        }
                        flag = false; // Reset flag after export
                        $$('Export').setValue(''); // Reset export selection
                    }
                }.bind(this),
            );
        });

        // Event listener for selecting a player
        this.on(this.app, 'player:select', (id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id); // Load data for selected player
        });
    }
}

// FILE DOCUMENTED
